module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Coffee1-7789900cf16dc15cfc29eed6adac37c9.svg";